import { fallbackCurrency } from 'components/common/Select/CountrySelect';
import { AuthContext } from 'contexts/AuthContext';
import { purchaseEvent } from 'global/constants';
import { PaymentMode } from 'global/interfaces/ITracking';
import { useContext, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getBasicPlanPriceFromCurrency, getDayPassPriceFromCurrency } from 'utils/currency';
import { pushToDataLayer } from 'utils/tagHelper';

export default function TrackCheckoutSuccess() {
  const authContext = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const sessionId: string | null = searchParams.get('session_id');
  const returnPath: string | null = searchParams.get('returnPath');
  const mode: string | null = searchParams.get('mode');
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionId && mode && returnPath) {
      const price: number =
        mode === PaymentMode.Subscription
          ? getBasicPlanPriceFromCurrency(fallbackCurrency.currencySymbol)
          : getDayPassPriceFromCurrency(fallbackCurrency.currencySymbol);

      pushToDataLayer(purchaseEvent, {
        ecommerce: {
          transaction_id: sessionId,
          value: price,
          currency: fallbackCurrency.currency,
          items: [
            {
              item_name: mode === 'subscription' ? 'Premium Plan' : 'Premium Day Pass', //Same as in Stripe products
              price,
            },
          ],
        },
        user: {
          email: authContext.user?.email,
        },
      });
      navigate(returnPath);
    } else {
      navigate(`/${returnPath ?? 'subscriptions'}`);
    }
  }, [authContext.user]);

  return <></>;
}
